import type { ReactNode } from 'react';
import { Link } from 'react-router';
import logo from '../assets/brand/logo-brands-people.png';
import code from '../assets/brand/logo-code.png';

/** Encabezado con el logo y la franja de color de brands.mx. */
export function SiteHeader({ children }: { children?: ReactNode }) {
  return (
    <header className="site-header">
      <img src={code} alt="" className="site-header__code" width={168} height={8} />
      <Link to="/" className="site-header__brand">
        <img src={logo} alt="Brands&People" width={168} height={25} />
      </Link>
      {children ? (
        <nav className="site-header__nav t-nav" aria-label="Principal">
          {children}
        </nav>
      ) : null}
    </header>
  );
}
